import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { LanguageService, Language } from '../../services/language.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
  standalone: false
})
export class LanguageSwitcherComponent implements OnInit {
  public languages: Language[] = [];
  public selectedLanguage: Language;
  public isDropdownOpen = false;
  public isUrlBasedLanguage = false;
  public hasUserOverride = false;
  public shouldHideSelector = false;

  constructor(
    private languageService: LanguageService,
    private elementRef: ElementRef,
    private translateService: TranslateService
  ) {
    this.languages = this.languageService.languages;
    this.selectedLanguage = this.languageService.getCurrentLanguage();
  }

  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }

  ngOnInit(): void {
    this.languageService.currentLanguage$.subscribe(language => {
      this.selectedLanguage = language;
      // Update flags whenever language changes
      this.isUrlBasedLanguage = this.languageService.isUrlBasedLanguage();
      this.hasUserOverride = this.languageService.hasUserLanguageOverride();
    });
    
    this.shouldHideSelector = this.languageService.shouldHideLanguageSelector();
  }

  public toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  public selectLanguage(language: Language): void {
    this.languageService.changeLanguage(language.code);
    this.isDropdownOpen = false;
  }

  public getFlagUrl(flag: string): string {
    return `assets/flags/${flag}.svg`;
  }

  public getTooltipText(): string {
    if (this.hasUserOverride) {
      return this.translateService.instant('languageSwitcher.userOverrideTooltip');
    }
    return this.isUrlBasedLanguage 
      ? this.translateService.instant('languageSwitcher.autoSelectedTooltip')
      : this.translateService.instant('languageSwitcher.clickToChangeTooltip');
  }

  public getAutoIndicatorTooltip(): string {
    if (this.hasUserOverride) {
      return this.translateService.instant('languageSwitcher.userOverrideTooltip');
    }
    return this.translateService.instant('languageSwitcher.autoIndicatorTooltip');
  }
}